module.exports = __webpack_public_path__ + "img/icon_waku_assign.8a85d617.png";